import ThreadPrefixes from "../../common/ThreadPrefixes";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import RatingStars from "../../common/RatingStars";

const CheckerInfos = [
	'Nhắn tin đúng Pass Bạn a KYNUVIET.PLUS',
	'Khi di chuyển quá 30 phút mới tới điểm hẹn thì hãy gọi lại cho hàng trước khi lấy phòng',
	'Lịch sự, vệ sinh sạch sẽ để được phục vụ như mong muốn.',
	'Từ chối phục vụ các bác quá già (trên 60 tuổi), đeo Bi hoặc dùng các đồ chơi tình dục, ' +
		'sử dụng ma túy, thuốc kích dục, quá say xỉn, dọa nạt, bạo dâm hoặc có những đòi hỏi quá đáng đối với em hàng.',
	'Các checker khi check về nhớ có report đánh giá kèm hình ảnh.',
	'Quá 30 phút sau khi nt số phòng, e hàng ko đến được coi như bỏ bom, hãy tố cáo theo hướng dẫn tại box Tòa Án Checkerviet.',
	'Xem kỹ đặc điểm nhận dạng của hàng nếu thấy ko đúng hãy tố cáo theo hướng dẫn tại box Tòa Án Kynuviet.',
	'HÃY BÌNH LUẬN VÀO BÀI VIẾT CHO CHÚNG TÔI BIẾT NẾU BẠN KO LIÊN LẠC ĐƯỢC VỚI SỐ TRÊN BÀI.',
	'CÁC BÌNH LUẬN NÂNG BI QUÁ ĐÀ VÀ CÁC BÌNH LUẬN KO CÓ BẰNG CHỨNG SẼ BỊ XÓA BỎ MÀ KO CẦN THÔNG BÁO.',
	'YÊU CẦU CÁC THÀNH VIÊN HÃY VIẾT REVIEWS TẠI BOX REVIEW GÁI GỌI ĐỂ ĐẢM BẢO CÔNG BẰNG.'
];

const GeneralInfos = [
	{
		key: 'nghedanh',
		title: 'Nghệ danh'
	},
	{
		key: 'namsinh',
		title: 'Năm sinh'
	},
	{
		key: 'khuvuc',
		title: 'Khu vực đi làm'
	},
	{
		key: 'khachsan',
		title: 'Giá nhà nghỉ / khách sạn'
	},
	{
		key: 'time',
		title: 'Thời gian đi làm'
	},
	{
		key: 'dacbiet',
		title: 'Dịch vụ đặc biệt (phụ phí nếu có)'
	},
	{
		key: 'cosplay',
		title: 'Trang phục cosplay'
	},
	{
		key: 'overnight',
		title: 'Qua đêm cùng khách'
	},
];

const ReviewInfos = [
	{
		key: 'height',
		title: 'Chiều cao (cm)'
	},
	{
		key: 'weight',
		title: 'Cân nặng (kg)'
	},
	{
		key: 'face',
		title: 'Khuôn mặt'
	},
	{
		key: 'v1',
		title: 'Vòng 1 (ngực)'
	},
	{
		key: 'v2',
		title: 'Vòng 2 (eo)'
	},
	{
		key: 'v3',
		title: 'Vòng 3 (mông)'
	},
	{
		key: 'bym',
		title: 'Bým'
	},
	{
		key: 'tatoo',
		title: 'Hình xăm trên nguười'
	},
	{
		key: 'voice',
		title: 'Giọng nói'
	},
	{
		key: 'other',
		title: 'Đặc điểm nhận dạng khác'
	},
];

const SexSkills = [
	{
		key: 'kiss',
		title: 'Cho khách hôn môi'
	},
	{
		key: 'kissboob',
		title: 'Cho khách hôn vú'
	},
	{
		key: 'squeezebreasts',
		title: 'Cho khách bóp vú'
	},
	{
		key: 'tevez',
		title: 'Cho khách vét máng (tevez)'
	},
	{
		key: 'cia',
		title: 'Cho khách xuất tinh miệng (CIA)'
	},
	{
		key: 'bj',
		title: 'Thổi kèn cho khách (BJ)'
	},
	{
		key: 'hj',
		title: 'Quay tay cho khách'
	},
	{
		key: 'wc',
		title: 'Dọn wc cho khách'
	},
	{
		key: 'some',
		title: 'Phục vụ some cùng khách'
	},
	{
		key: '69',
		title: 'Xếp hình 69-96 cùng khách'
	},
	{
		key: 'shower',
		title: 'Tắm chung cùng khách'
	},
	{
		key: 'url',
		title: 'Link bài some cùng e khác'
	},
	{
		key: 'url_prev',
		title: 'Link bài viết trước'
	},
];

const Reviews = [
	{
		key: 'url_root',
		title: 'Link bài viết',
		type: 'url'
	},
	{
		key: 'dannhgiadang',
		title: 'Đánh giá dáng người',
		type: 'rating_score'
	},
	{
		key: 'danhgiada',
		title: 'Đánh giá nước da',
		type: 'rating_score'
	},
	{
		key: 'danhgiamat',
		title: 'Đánh giá khuôn mặt',
		type: 'rating_score'
	},
	{
		key: 'danhgianguc',
		title: 'Đánh giá ngực',
		type: 'rating_score'
	},
	{
		key: 'danhgiaeo',
		title: 'Đánh giá eo',
		type: 'rating_score'
	},
	{
		key: 'danhgiamong',
		title: 'Đánh giá mông',
		type: 'rating_score'
	},
	{
		key: 'danhgiabym',
		title: 'Đánh giá bým',
		type: 'rating_score'
	},
	{
		key: 'danhgiathoigian',
		title: 'Đánh giá thời gian chờ',
		type: 'raw'
	},
	{
		key: 'danhgialamtinh',
		title: 'Đánh giá kỹ năng làm tình',
		type: 'raw'
	},
	{
		key: 'danhgiakhigap',
		title: 'Đánh giá thái độ khi gặp',
		type: 'raw'
	},
	{
		key: 'danhgiakhicheck',
		title: 'Đánh giá thái độ khi check',
		type: 'raw'
	},
	{
		key: 'danhgiagaplai',
		title: 'Đánh giá khả năng gặp lại',
		type: 'raw'
	},
	{
		key: 'gaigoisieucap',
		title: 'Đánh giá có được mác IDOL KNV',
		type: 'raw'
	},
];

const InfoBlock = ({title, children}) => {
	return (
		<div className="">
			<div className="text-xl text-center font-bold text-yellow-400 mb-4">
				{title}
			</div>

			<div>
				{children}
			</div>
		</div>
	);
}

const InfoItem = ({thread, title, value, valueKey, type = null}) => {
	if (value === 'yes') {
		value = 'Có';
	} else if (value === 'no') {
		value = 'Không';
	}

	return (
		<div className="flex items-center justify-center text-white">
									<span className="w-1/2 text-right pr-2">
										{title}:
									</span>

			<b className="w-1/2 text-left">
				{type === 'url' && (
					<a href={value} className="text-url hover:text-white hover:underline">{value}</a>
				)}

				{type === 'rating_score' && (
					<div className="inline-block">
						<RatingStars score={value} />
					</div>
				)}

				{(type === 'raw') && (
					<span>{thread.custom_fields_raw[valueKey]}</span>
				)}

				{(type === undefined || type === null) && (
					<span>{value}</span>
				)}
			</b>
		</div>
	);
}

const ThreadPromoteInfo = ({thread}) => {
	return (
		<div>
			<section className="text-white font-bold text-center">
				<h3>
					<span className="inline-block mr-2">
						<ThreadPrefixes thread={thread}/>
					</span>

					<span className="inline-block">
						{thread.title}
					</span>
				</h3>
			</section>

			{thread.is_promote && (
				<>
					<hr className="my-2 border-gray-600"/>

					{(!thread.ft_temp_off && thread.discussion_open) ? (
						<section className="text-xl text-white font-bold text-center">
							Số điện thoại: <span className="text-yellow-400">{thread.ft_phone}</span>
							- Giá: <span className="text-yellow-400">{thread.price}K</span>
						</section>
					) : (
						<section className="text-xl text-white font-bold text-center">
							Giá: <span className="text-yellow-400">{thread.price}K</span>
						</section>
					)}

					<hr className="my-2 border-gray-600"/>

					<div className="text-center mb-4">
						<InfoBlock title={'THÔNG TIN GÁI GỌI'}>
							<ul className="list-none">
								{GeneralInfos.map((info, index) => (
									<li key={index} className="mb-2">
										<InfoItem title={info.title} value={thread.custom_fields[info.key]}/>
									</li>
								))}
							</ul>
						</InfoBlock>
					</div>

					<div className="text-center mb-4">
						<InfoBlock title={'ĐÁNH GIÁ VÀ ĐẶC ĐIỂM NHẬN DẠNG'}>
							<ul className="list-none">
								{ReviewInfos.map((info, index) => (
									<li key={index} className="mb-2">
										<InfoItem title={info.title} value={thread.custom_fields[info.key]}/>
									</li>
								))}
							</ul>
						</InfoBlock>
					</div>

					<div className="text-center mb-4">
						<InfoBlock title={'THÔNG TIN KỸ NĂNG LÀM TÌNH CÁ NHÂN'}>
							<ul className="list-none">
								{SexSkills.map((info, index) => (
									<li key={index} className="mb-2">
										<InfoItem title={info.title} value={thread.custom_fields[info.key]}/>
									</li>
								))}
							</ul>
						</InfoBlock>
					</div>

					<InfoBlock title={'THÔNG TIN DÀNH CHO CHECKER'}>
						<ul className="list-none">
							{CheckerInfos.map((info, index) => (
								<li key={index} className="text-white">
									<FontAwesomeIcon icon={faCheck} className="inline-block mr-2"/>
									<p className="inline-block">{info}</p>
								</li>
							))}
						</ul>
					</InfoBlock>
				</>
			)}

			{thread.is_reviews && (
				<div className="text-center mb-4">
					<InfoBlock title={'ĐÁNH GIÁ GÁI GỌI'}>
						<ul className="list-none">
							{Reviews.map((info, index) => (
								<li key={index} className="mb-2">
									<InfoItem
										thread={thread}
										title={info.title}
										value={thread.custom_fields[info.key]}
										valueKey={info.key}
										type={info.type}
									/>
								</li>
							))}
						</ul>
					</InfoBlock>
				</div>
			)}
		</div>
	);
}

export default ThreadPromoteInfo;